(function () {
  "use strict";

  homeResource.$inject = ['$resource', 'errorHandler', 'mtypes'];
  angular
    .module('trainerWebApp.resources')
    .factory('homeResource', homeResource);

  function homeResource($resource, errorHandler, mtypes) {

    var homeRes = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/trainer-home');
    var courseRes = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/trainer-home/course/:courseId');
    var seriesRes = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/trainer-home/series/:seriesId');
    var catalogRes = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/trainer-home/catalog/:catalogId');

    homeRes.prototype.load = function load(resultCb, errorCb) {
      return homeRes.get(resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    // todo - append series/course etc
    homeRes.prototype.getCourse = function getCourse(courseId, resultCb, errorCb) {
      return homeRes.get(courseId, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.getSeries = function getSeries(seriesId, resultCb, errorCb) {
      return homeRes.get(seriesId, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.createSeries = function createSeries(resultCb, errorCb) {
      return $resource(mfConfig.trainerMvcEndpoint + '/CreateSeries')
        .save(resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.deleteSeries = function deleteSeries(seriesId, resultCb, errorCb) {
      return $resource(mfConfig.trainerMvcEndpoint + '/DeleteSeries')
        .save({seriesId: seriesId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.createCourse = function createCourse(resultCb, errorCb) {
      return $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course')
        .save(resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.createLiveCourse = function createLiveCourse(resultCb, errorCb) {
      return $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course')
        .save({type: mtypes.courseType.live}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.deleteCourse = function deleteCourse(courseId, resultCb, errorCb) {
      return $resource(mfConfig.trainerMvcEndpoint + '/DeleteCourse')
        .save({courseId: courseId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.copyCourse = function copyCourse(courseId, resultCb, errorCb) {
      return $resource(mfConfig.trainerMvcEndpoint + '/CopyCourse')
        .save({courseId: courseId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.copyFreeCourse = function copyFreeCourse(courseId, resultCb, errorCb) {
      return $resource(mfConfig.trainerMvcEndpoint + '/CopyCourse')
        .save({courseId: courseId, keepName: true}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    }

    homeRes.prototype.previewCourse = function previewCourse(courseId, resultCb, errorCb) {
      return $resource(mfConfig.trainerMvcEndpoint + '/PreviewCourse')
        .save({courseId: courseId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.getCoursePreviewItems = function getCoursePreviewItems(courseId, resultCb, errorCb) {
      return $resource(mfConfig.trainerMvcEndpoint + '/GetCoursePreviewItems')
        .save({courseId: courseId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.getCourseDetail = function getCourseDetail(courseId, resultCb, errorCb) {
      return courseRes.get({courseId: courseId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.getSeriesDetails = function getSeriesDetails(seriesId, resultCb, errorCb) {
      return seriesRes.get({seriesId: seriesId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    homeRes.prototype.getCatalogDetails = function getCatalogDetails(catalogId, resultCb, errorCb) {
      return catalogRes.get({catalogId: catalogId}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new homeRes;
  }

})();
